import { DSModal } from "@components/design-system/organisms";

const ResetTemplateModal = ({
  shouldShow,
  hideModal,
  confirmAction,
}) => (
  <DSModal
    isOpen={shouldShow}
    onClose={hideModal}
    title="Reset Template"
    actions={[
      { label: "Cancel", variant: "cancel", onClick: hideModal },
      {
        label: "Reset",
        variant: "primary",
        onClick: confirmAction,
        dataTestId: "confirm-button",
      },
    ]}
    dataTestId="reset-template-modal"
  >
    <p>
      This action will reset all of your progress and{" "}
      <b>cannot be undone.</b>
    </p>
    <p>Are you sure you want to proceed?</p>
  </DSModal>
);

export default ResetTemplateModal;
